export default "__VITE_ASSET__6990c2f5__"